import { removeDiacritics } from "./removeDiacritics";
import { removeInvalidChars } from "./removeInvalidChars";

export function XML_AddLink(drawElement, linkBookmark, xmin, ymin, xmax, ymax) {
  var s = drawElement.GetStream();
  drawElement.OutputElementHead(s, "link");
  drawElement.OutputElementQuad("box", xmin, ymin, xmax, ymax, s);
  linkBookmark = removeDiacritics(linkBookmark);
  linkBookmark = removeInvalidChars(linkBookmark);
  drawElement.OutputSimpleElement("bm", linkBookmark, s);
  drawElement.OutputElementTail(s, "link");
}
